import { IServico } from '../../../../types/listItems';

export function Item({ cod_servico, titulo }: IServico) {
    return (
        <li className="list-none">
            <a
                href={`https://api-portal.itajai.sc.gov.br/portaladm-pmitajai/servico/acesso/cod/${cod_servico}`}
                target="_blank"
                rel="noreferrer"
                className="text-on-surface dark:text-on-surface-dark no-underline block py-2 text-sm transition-colors hover:text-primary dark:hover:text-secondary"
            >
                • {titulo}
            </a>
        </li>
    )
}